import * as React from 'react';
import { PageWidget } from '../widgets/layout/PageWidget';
import { HomePageContent } from './HomePageContent';
import { PlatformStoryWidget } from '../widgets/home/platform-story/PlatformStoryWidget';
import { S } from '../widgets/home/platform-story/styles';

export const HomePage: React.FC = () => (
  <S.Backdrop>
    <PageWidget title="Meet JourneyApps Platform" width={1400} topPadding={0}>
      <S.HeroFrame>
        <PlatformStoryWidget withIntro />
      </S.HeroFrame>
      <S.HomeContent>
        <HomePageContent />
      </S.HomeContent>
    </PageWidget>
  </S.Backdrop>
);
